import React, { useState } from 'react';
import { notification } from '@oscar/theme';
import { useSelector } from 'react-redux';
import { getMessages } from '../selectors';
import { useDeepCompareEffect } from '@oscar/utils';
import { IMessage } from '..';

const Message = () => {
  const messages = useSelector(getMessages);
  const [appearance, setAppearance] = useState<number[]>([]);

  useDeepCompareEffect(() => {
    const showMessages = messages.filter(
      message => !appearance.includes(message.id),
    );
    showMessages.forEach(({ payload, type, delay }) => {
      notification[type]({
        message: payload.title,
        description: payload.message,
        duration: delay / 1000,
      });
      setAppearance(showMessages.map(item => item.id));
    });
  }, [messages]);

  return null;
};

export default Message;
